"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledSwitchGroup = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _SwitchGroupMixin = require("../../mixins/components/SwitchGroupMixin");
var StyledSwitchGroup = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "StyledSwitchGroup",
  componentId: "c11n-8-107-0__sc-10lu0n5-0"
})(["", ""], _SwitchGroupMixin.SwitchGroupMixin);
exports.StyledSwitchGroup = StyledSwitchGroup;